import script from "./CardImg-wap.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardImg-wap.vue?vue&type=script&lang=ts&setup=true"

import "./CardImg-wap.vue?vue&type=style&index=0&id=0b64551c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b64551c"]])

export default __exports__